export default "__VITE_ASSET__BAs8DkxU__"